import refreshCaptcha from "../utils/captcha-refresh";

const form15 = document.querySelector('#gform_15');
let requiredElementsTab = [];


if('undefined'!=typeof(form15) && !!form15) {

    const requiredElements = form15.querySelectorAll('[aria-required="true"]');

    requiredElements.forEach((element)=>{
        requiredElementsTab.push(element.id.split('_')[2]);
    });

    let getNextSibling = function (elem, selector){
        let sibling = elem.nextElementSibling;
        if (!selector) return sibling;
        while (sibling) {
            if (sibling.matches(selector)) return sibling;
            sibling = sibling.nextElementSibling
        }
    };

    gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
        if(15!=formId) return;

        let validationMessage = getNextSibling(elem.parentNode,'.gfield_validation_message');

        if(requiredElementsTab.includes(fieldId)) {

            if('checkbox'==elem.type) {

                if(elem.checked) {
                    (undefined!==validationMessage) ? validationMessage.style.display = 'none' : null;
                    elem.setAttribute("aria-invalid", "false");
                } else {
                    (undefined!==validationMessage) ? validationMessage.style.display = 'block' : null;
                    elem.setAttribute("aria-invalid", "true");
                }

            } else {

                if(elem.value.length>0) {
                    (undefined!==validationMessage) ? validationMessage.style.display = 'none' : null;
                    elem.setAttribute("aria-invalid", "false");
                } else {
                    (undefined!==validationMessage) ? validationMessage.style.display = 'block' : null;
                    elem.setAttribute("aria-invalid", "true");
                }

            }

        }
    }, 10, 3 );

}